import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

export const types = [
  'text',
  'number',
  'password',
  'email',
  'tel',
  'url',
  'search',
  'date',
  'datetime-local',
  'month',
  'week',
  'time',
  'checkbox',
  'radio',
];

//------------------------------------------------------------------------------

const Input = ({
  className,
  id,
  type,
  pattern,
  maxLength,
  placeholder,
  defaultValue,
  value,
  onChange,
  onFocus,
  onBlur,
}) =>
  <input
    className={classNames('Input', className)}
    id={id}
    name={id}
    type={type}
    pattern={pattern}
    maxLength={maxLength}
    placeholder={placeholder}
    defaultValue={defaultValue}
    value={value}
    onChange={onChange}
    onFocus={onFocus}
    onBlur={onBlur}
  />;

Input.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(types),
  pattern: PropTypes.string,
  maxLength: PropTypes.number,
  placeholder: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

Input.defaultProps = {
  className: null,
  type: 'text',
  pattern: null,
  maxLength: null,
  placeholder: null,
  defaultValue: undefined,
  value: undefined,
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Form/Field/Input/index.js